<template>
  <MarkupSectionText
    v-if="modifiedConfigData.Text"
    class="mb-16"
    :config-data="{ Text: modifiedConfigData.Text }"
  />

  <MarkupSimpleBulletList :config-data="modifiedConfigData.Usp" />
</template>

<script lang="ts" setup>
type bullet = {
  Text: string;
};
interface Props {
  configData: {
    Text: string;
    Bullets: bullet[];
  };
}

const props = defineProps<Props>();

const modifiedConfigData = {
  Text: props.configData.Text,
  Usp: {
    Items: props.configData.Bullets.map((item: bullet) => ({
      Text: item.Text,
    })),
  },
};
</script>

<style></style>
